import { allowedRoles } from "roles_management/rolesList";
import { generateSpecificModuleRoutes, RouteHandler } from "./RouteHandler";
import { ExpertToolDocuments, IndicatorScoreCardView, IndicatorScoreCards, DataExplorer, PresetExtraction, CountryProfile, PipelineSchedule} from "routes_management";
import Index from "pages/backend/partner-tech/Index";
import FrontendLayout from "pages/frontend/FrontendLayout";
import NotificationManagement from "pages/backend/NotificationManagement";
import PowerBiDashboard from "pages/frontend/components/country-profile/PowerBiDashboard";

/**
 * This function is responsible for generating routes of the system.
 * @param {object|null} user 
 * @returns 
 */
export const generateRoutes = (user = null) => {
    return [
        ...generateSpecificModuleRoutes({
            hasWrapper: false,
        }, [
            {
                path: "/indicator-score-card",
                element: <IndicatorScoreCards />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/country-profile",
                element: <CountryProfile />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                    dataMigrator: true,
                    superAdministrator: true,
                    businessAdmin: true,
                    itAdmin: true,
                    cbdStaff: true,
                    dsdStaff: true,
                    arvpStaff: true,
                    radStaff: true,
                    otherStaff: true,
                    woahDirection: true,
                    comex: true,
                    headRrSrr: true,
                    staffRrSrr: true,
                    delegates: true,
                    focalPoints: true,
                    pnDG: true,
                    pnDR: true,
                    dtis: true,
                    did: true,
                    docCell: true,
                    experts: true,
                    prd: true,
                    eventCoordU: true,
                    genServU: true,
                    budgetU: true,
                    scienceDep: true,
                    accountingU: true,
                    commDep: true,
                    publicationU: true,
                    pcmU: true,
                    hr: true,
                    legalAffairU: true,
                    eid: true,
                    standardsDep: true,
                    wahiad: true,
                    externalStaff: true,
                    otherNationalOfficials: true,
                    specialistCommissions: true,
                    woahReferenceCentres: true,
                    woahAdHocGroups: true,
                    woahWorkingGroups: true,
                    institutionalPartners: true,
                    resourcePartnersDonors: true,
                    delegateProxy: true,
                    missionContactPerson: true
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/notification-management",
                element: <NotificationManagement />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                    dataMigrator: true,
                    superAdministrator: true,
                    businessAdmin: true,
                    itAdmin: true,
                    cbdStaff: true,
                    dsdStaff: true,
                    arvpStaff: true,
                    radStaff: true,
                    otherStaff: true,
                    woahDirection: true,
                    comex: true,
                    headRrSrr: true,
                    staffRrSrr: true,
                    delegates: true,
                    focalPoints: true,
                    pnDG: true,
                    pnDR: true,
                    dtis: true,
                    did: true,
                    docCell: true,
                    experts: true,
                    prd: true,
                    eventCoordU: true,
                    genServU: true,
                    budgetU: true,
                    scienceDep: true,
                    accountingU: true,
                    commDep: true,
                    publicationU: true,
                    pcmU: true,
                    hr: true,
                    legalAffairU: true,
                    eid: true,
                    standardsDep: true,
                    wahiad: true,
                    externalStaff: true,
                    otherNationalOfficials: true,
                    specialistCommissions: true,
                    woahReferenceCentres: true,
                    woahAdHocGroups: true,
                    woahWorkingGroups: true,
                    institutionalPartners: true,
                    resourcePartnersDonors: true,
                    delegateProxy: true,
                    missionContactPerson: true
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/data-explorer",
                element: <DataExplorer />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/indicator-score-card-view/:view",
                element: <IndicatorScoreCardView />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/partner-tech/index",
                element: <Index />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                    itAdmin: true,
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/expert-tool-document/index",
                element: <ExpertToolDocuments />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                    itAdmin: true,
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/data-explorer/extraction",
                element: <PresetExtraction />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/pipeline-settings",
                element: <PipelineSchedule />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                },
                userRole: user ? user.role_id : null
            },
            {
                path: "/country-dashboard/:id",
                element: <PowerBiDashboard />,
                secure: true,
                isFrontendLayout: true,
                allowedRoles: {
                    ...allowedRoles,
                    businessAdmin: true,
                    dataMigrator: true,
                    superAdministrator: true,
                    businessAdmin: true,
                    itAdmin: true,
                    cbdStaff: true,
                    dsdStaff: true,
                    arvpStaff: true,
                    radStaff: true,
                    otherStaff: true,
                    woahDirection: true,
                    comex: true,
                    headRrSrr: true,
                    staffRrSrr: true,
                    delegates: true,
                    focalPoints: true,
                    pnDG: true,
                    pnDR: true,
                    dtis: true,
                    did: true,
                    docCell: true,
                    experts: true,
                    prd: true,
                    eventCoordU: true,
                    genServU: true,
                    budgetU: true,
                    scienceDep: true,
                    accountingU: true,
                    commDep: true,
                    publicationU: true,
                    pcmU: true,
                    hr: true,
                    legalAffairU: true,
                    eid: true,
                    standardsDep: true,
                    wahiad: true,
                    externalStaff: true,
                    otherNationalOfficials: true,
                    specialistCommissions: true,
                    woahReferenceCentres: true,
                    woahAdHocGroups: true,
                    woahWorkingGroups: true,
                    institutionalPartners: true,
                    resourcePartnersDonors: true,
                    delegateProxy: true,
                    missionContactPerson: true
                },
                userRole: user ? user.role_id : null
            },
        ]),
    ];
}
